import type { QuotesFilters } from '../types';

/**
 * Query key factory for quotes feature
 * Follows TanStack Query best practices for key organization
 */
export const quoteKeys = {
  all: ['quotes'] as const,
  lists: () => [...quoteKeys.all, 'list'] as const,
  list: (filters: QuotesFilters) => [...quoteKeys.lists(), filters] as const,
  details: () => [...quoteKeys.all, 'detail'] as const,
  detail: (id: string) => [...quoteKeys.details(), id] as const,
  byNumber: (quoteNumber: string) => [...quoteKeys.all, 'byNumber', quoteNumber] as const,
  operationsAuditLogs: (id: string, params?: { pageNumber?: number; pageLength?: number }) =>
    [...quoteKeys.all, 'operationsAuditLogs', id, params] as const,
  v3details: () => [...quoteKeys.all, 'v3detail'] as const,
  v3detail: (id: string) => [...quoteKeys.v3details(), id] as const,
  skus: (id: string) => [...quoteKeys.all, 'skus', id] as const,
  html: (id: string) => [...quoteKeys.all, 'html', id] as const,
  stats: (filters?: Partial<QuotesFilters>) =>
    [...quoteKeys.all, 'stats', filters] as const,
  customers: () => [...quoteKeys.all, 'customers'] as const,
  accountsInfinite: (search: string) =>
    [...quoteKeys.all, 'accounts', 'infinite', search] as const,
  account: (id: string) => [...quoteKeys.all, 'accounts', 'detail', id] as const,
  salesUsers: () => [...quoteKeys.all, 'salesUsers'] as const,
  orgUsers: (orgId: string) => [...quoteKeys.all, 'orgUsers', orgId] as const,
  changelog: (id: string) => [...quoteKeys.all, 'changelog', id] as const,
  pricelists: () => [...quoteKeys.all, 'pricelists'] as const,
  skuCatalogInfinite: (search: string) => [...quoteKeys.all, 'skuCatalogInfinite', search] as const,
  subscriptions: (customerId: string) => [...quoteKeys.all, 'subscriptions', customerId] as const,
  invoices: (quoteNumber: string) => [...quoteKeys.all, 'invoices', quoteNumber] as const,
  nextQuoteNumber: () => [...quoteKeys.all, 'nextQuoteNumber'] as const,
  sensors: (quoteNumber: string) => [...quoteKeys.all, 'sensors', quoteNumber] as const,
  selectableSensors: (customerId: string, params?: Record<string, unknown>) =>
    [...quoteKeys.all, 'selectableSensors', customerId, params] as const,
};
